module.exports = __webpack_public_path__ + "static/KyleHawthorne_lab-622d9afdcf7096d0e2a32b85ea44d329.png";